import { KeyValuePipe, NgClass } from '@angular/common'
import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AdviceOption, MessageService, Recommendation } from '@bequeathed/ngx-services'
import { LoggerService } from '@bequeathed/ngx-app-core'
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component'
import {
    NgbDropdown,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle
} from "@ng-bootstrap/ng-bootstrap"

const LOG: LoggerService = LoggerService.get('AdviceControlComponent')

/**
 * Advice Interview form control to display a recommendation
 *
 * @author Bilal Yasin
 */
@Component({
    selector: 'advice-control',
    templateUrl: './advice-control.component.html',
    styleUrls: ['./advice-control.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        ConfirmPopupComponent,
        // Angular
        NgClass,
        ReactiveFormsModule,
        FormsModule,
        KeyValuePipe,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu,
        NgbDropdownItem,
        NgbDropdownButtonItem,
        NgbDropdownItem,
    ],
})
export class AdviceControl {

    // @ts-expect-error injected
    @Input() config: AdviceOption
    // @ts-expect-error injected
    @Input() recommendation: Recommendation
    // @ts-expect-error injected
    @Input() adviceId: number
    // @ts-expect-error injected
    @Input() interviewId: number
    // @ts-expect-error injected
    @Input() lastOption: boolean
    @Input() prefix = 'general'
    @Input() DEBUG = false

    // @ts-expect-error injected
    @ViewChild('confirmPopup') confirmationPopup: ConfirmPopupComponent

    OTHER = 'other'
    flagAsInvalid = false

    @Output() interviewCompleteEvent: EventEmitter<void> = new EventEmitter<void>()

    constructor(protected messageService: MessageService) {
    }

    get messages(): MessageService {
        return this.messageService
    }

    get invalid(): boolean {
        return this.flagAsInvalid = this.recommendation.status === 'NOT_ANSWERED'
            || (
                this.recommendation.status === 'REJECTED'
                && this.recommendation.rejectionCode === 'other'
                && !this.recommendation.rejectionText
            )
    }

    updateStatus(value: string, rejectionOption?: string, rejectionMsgCode?: string) {
        this.recommendation.status = value
        if (rejectionOption) {
            this.updateRejectionReason(rejectionOption, rejectionMsgCode!)
        }

        if (value === 'ACCEPTED' || rejectionOption !== 'other' || !!this.recommendation.rejectionText) {
            this.flagAsInvalid = false
        }
        if (this.recommendation.name?.includes('requirement') && value === 'REJECTED') {
            this.confirmRejected()
        }
    }

    updateRejectionReason(code: string, text: string) {
        this.recommendation.rejectionCode = code
        if (!this.rejectionCodeIsOther()) {
            this.recommendation.rejectionText = this.messages.getText(this.config.rejectionOptions.get(code)!, text)
        } else {
            this.recommendation.rejectionText = undefined
        }
    }

    async confirmRejected() {
        LOG.debug('confirmRejected', `${this.recommendation}`)
        return this.confirmationPopup.open({
            modalTitle: this.messageService.getText('ADVICE.popup.title', 'Are you sure?'),
            confirmButtonLabel: this.messageService.getText('ADVICE.popup.yes', `Yes, I'm sure`),
            onClose: () => true,
            dismissButtonLabel: this.messageService.getText('ADVICE.popup.no', 'Go back'),
            onDismiss: () => true
        })
    }

    rejectionCodeIsOther(): boolean {
        return this.recommendation?.rejectionCode === this.OTHER
    }

    scroll = (el: HTMLElement) => {
        el.scrollIntoView({behavior: 'smooth', block: 'center'})
    }
}
